export default __webpack_public_path__ + "static/media/emoji-point.78a3603d.svg";